import React, { Component } from 'react';
import styled from 'styled-components';
import { AUTH_FORUM_BG } from '../../config/media';
import { WHITE_COLOR } from '../../config/colors';

const Wrapper = styled.div`
	position: absolute;
	left: 0;
	top: 0;
	width: 100%;
	height: 100%;
	.bg-wrapper-text {
		position: absolute;
		bottom: 60px;
		left: 60px;
		color: ${WHITE_COLOR};
		h2 {
			font-size: 32px;
			color: ${WHITE_COLOR};
			font-weight: bold;
		}
		p {
			font-size: 14px;
			line-height: 16px;
		}
		.btn-link {
			color: ${WHITE_COLOR};
			font-size: 10px;
			padding: 7px 14px;
			border: 2px solid ${WHITE_COLOR};
			text-decoration: none;
			font-weight: bold;
		}
	}
	.bg-wrapper-image {
		width: 100%;
		height: 100%;
		background-position: center;
		background-size: cover;
		background-image: url(${AUTH_FORUM_BG});
	}
	@media (max-width: 1200px) {
		.bg-wrapper-text {
			h2 {
				font-size: 20px;
			}
			p {
				font-size: 12px;
			}
		}
	}
`;
class Forum extends Component {
	render() {
		return (
			<Wrapper>
				<div className="bg-wrapper-image"></div>
				<div className="bg-wrapper-text">
					<h2>Join the discussion</h2>
					<p>
						Find answers fast directly from experts on the
						forums.
					</p>
					<a
						href="https://forum.hollaex.com"
						title="hollaex forum"
						target="_blank"
						rel="noopener noreferrer"
						className="btn-link"
					>
						Visit Forum
					</a>
				</div>
			</Wrapper>
		);
	}
}

export default Forum;
